import { render } from "./ListCharacters.vue?vue&type=template&id=48c3b4bb&lang=html"
import script from "./ListCharacters.vue?vue&type=script&lang=js"
export * from "./ListCharacters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__